import {Rating as MUIRating} from '@mui/material'
import React from 'react'

interface RatingProps extends React.ComponentProps<typeof MUIRating> {}

export const Rating: React.FC<RatingProps> = (props) => {
  return <MUIRating {...props} />
}
